<app-header></app-header>

<section class="home">
  <form
    class="form-consulta"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    (keydown.enter)="onEnter($event)"
    novalidate
  >
    <header class="form-consulta__cabecalho">
      <h1 class="form-consulta__titulo">Extrato de Desligamento</h1>
      <p class="form-consulta__descricao">
        Informe os dados abaixo para gerar o extrato de desligamento.
      </p>
    </header>

    <div class="form-consulta__campos">
      <vivest-autocomplete
        formControlName="empresa"
        label="Empresa"
        name="empresa"
        placeholder="Selecione a empresa"
        required
        [options]="empresaOptions()"
        [status]="status('empresa')"
        [errorMessage]="mensagemErro('empresa')"
      ></vivest-autocomplete>

      <vivest-autocomplete
        formControlName="plano"
        label="Plano"
        name="plano"
        placeholder="Selecione o plano"
        required
        [options]="planoOptions"
        [status]="status('plano')"
        [errorMessage]="mensagemErro('plano')"
      ></vivest-autocomplete>

      <vivest-input
        formControlName="matricula"
        vivestFormat="digits"
        label="Matrícula"
        name="matricula"
        type="text"
        autocomplete="off"
        placeholder="Informe a matrícula"
        required
        [status]="status('matricula')"
        [errorMessage]="mensagemErro('matricula')"
      ></vivest-input>

      <vivest-input
        formControlName="cpf"
        vivestFormat="cpf"
        label="CPF"
        name="cpf"
        type="tel"
        autocomplete="off"
        placeholder="000.000.000-00"
        required
        [status]="status('cpf')"
        [errorMessage]="mensagemErro('cpf')"
      ></vivest-input>
    </div>

    <vivest-button
      variant="primary"
      full-width
      size="md"
      [disabled]="desabilitado()"
      (click)="onSubmit()"
    >
      Gerar
    </vivest-button>
  </form>
</section>
